import { BehaviorSubject, filter } from 'rxjs';
import { ensureGlobalState, logInstanceId } from '../helpers/state';
logInstanceId("cart.service");
const SHARED_REQUEST_CONFIG = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};
export const cartSubject$ = ensureGlobalState("untuckit.cart", new BehaviorSubject(null));
export const cartState$ = cartSubject$.pipe(filter(cart => cart !== null));
export async function updateCart(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error updating cart", json, response.headers, request);
        throw new Error();
    }
    return json;
}
export async function addToCart(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error adding item to cart", json, response.headers, request);
        throw new Error();
    }
    getCart();
    return json;
}
export async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error fetching cart", json, response.headers, null);
        throw new Error();
    }
    json.items = json.items.filter(i => i.quantity > 0) || []; // shopify will sometimes return out of stock items with 0 quantity
    cartSubject$.next(json);
    return json;
}
export class ChangeLineItemError extends Error {
    payload;
    constructor(message, payload) {
        super(message);
        this.name = "ChangeLineItemError";
        this.payload = payload;
    }
}
export async function changeLineItem(request) {
    const requestOptions = {
        ...SHARED_REQUEST_CONFIG,
        body: JSON.stringify(request)
    };
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, requestOptions);
    const json = await response.json();
    if (!response.ok) {
        logErrors("Error changing line item", json, response.headers, request);
        let reason = 'GENERIC';
        let passedthroughServerMessage = '';
        if (response.status === 422) {
            const lowercaseMessage = (json.message || '').toLowerCase();
            // not great, but shopify doesn't provide error codes
            if (lowercaseMessage.includes('sold out')) {
                reason = 'SOLD_OUT';
            }
            else if (lowercaseMessage.includes('due to availability')) {
                reason = 'CANNOT_ADD_INVENTORY';
                passedthroughServerMessage = json.message;
                getCart(); // refresh the cart to get the latest inventory data
            }
        }
        throw new ChangeLineItemError('', { reason, passedthroughServerMessage });
    }
    getCart();
    return json;
}
function getResponseError(json) {
    return json?.description || json?.message || 'unknown';
}
function logErrors(description, response, headers, requestPayload) {
    const responseError = getResponseError(response);
    console.error(`${description}:`, responseError);
    const requestId = headers.get('x-request-id');
    if (requestId) {
        console.error("cart request id", requestId, JSON.stringify(requestPayload));
    }
}
